import { render } from "./PatientDatatablePlanTreatmentActions.vue?vue&type=template&id=f7176f1a&scoped=true"
import script from "./PatientDatatablePlanTreatmentActions.vue?vue&type=script&lang=js"
export * from "./PatientDatatablePlanTreatmentActions.vue?vue&type=script&lang=js"

import "./PatientDatatablePlanTreatmentActions.vue?vue&type=style&index=0&id=f7176f1a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7176f1a"]])

export default __exports__